import Icon from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { SVGDiagnose, SVGPeople, SVGSkill } from '../../images';

const Insight = () => {
  const { t } = useTranslation();
  const menus = [
    {
      key: 'diagnose',
      label: t('diagnose_coming_soon'),
      icon: <Icon component={SVGDiagnose} />,
    },
    {
      key: 'people',
      label: t('people_coming_soon'),
      icon: <Icon component={SVGPeople} />,
    },
    {
      key: 'skillset',
      label: t('skillset_coming_soon'),
      icon: <Icon component={SVGSkill} />,
    },
  ];
  const location = useLocation();
  const navigate = useNavigate();

  const { pathname } = location;

  const selectedKeys = pathname.split('/').slice(2);

  const [defaultOpenKeys, setDefaultOpenKeys] = useState<string[]>([]);

  return (
    <Layout style={{ height: '100%' }}>
      <Layout.Sider style={{ backgroundColor: '#3d5727' }}>
        <Menu
          selectedKeys={selectedKeys}
          defaultOpenKeys={defaultOpenKeys}
          theme="light"
          items={menus}
          onClick={({ key, keyPath }) => {
            navigate(key);
            setDefaultOpenKeys(keyPath);
          }}
        />
      </Layout.Sider>
      <Layout.Content>
        <Outlet />
      </Layout.Content>
    </Layout>
  );
};

export default Insight;
